import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-settings.svg";
import * as styles from "./Icon.module.scss";

type SettingsProps = React.SVGProps<SVGSVGElement>;

export const Settings = ({ className, ...props }: SettingsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
